// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';

import applications from '../applications';
import { IconAppPassages, IconAppGradeBook, IconAppDining } from '../../_Icons';

import styles from './NotConnected.scss';


const icons = {
  dnevnik: <IconAppGradeBook className={styles.appIcon} />,
  cafeteria: <IconAppDining className={styles.appIcon} />,
  access: <IconAppPassages className={styles.appIcon} />,
};

type Props = {
  connected: Array<boolean>,
  t: (s: string, b: Object) => string,
}

const NotConnected = ({ connected, t }: Props) => (
  <div className={styles.root}>
    {applications.map((app, i) =>
      !connected[i]
      && <div className={styles.warn} key={app}>
        <div>
          {icons[app]}
        </div>
        <div className={styles.warnText}>
          {t('not_connected_text', { app: t(`subs:${app}_short`) })}
        </div>
      </div>)}
  </div>
);

export default withTranslation('children')(NotConnected);
